import React from 'react';
import styles from './MapCredits.module.css';

/**
 * The attribution lines owed for whatever the map is currently rendering.
 *
 * Attribution, not explanation. The obligation follows the data being used, not
 * a swatch being shown: the ONS and OS country boundaries are loaded on every
 * map to classify the region and have no legend card at all.
 *
 * It used to render at the foot of the legend panel. It now renders at the foot
 * of Zone Details, because the block was taking more of the 232px panel than the
 * legend itself. It sits outside the land-characteristics block so that it still
 * renders for a livestock zone, where the map draws the same layers but the land
 * panel is not shown.
 *
 * Zone Details only opens when a farmer selects a zone, so these credits are not
 * on screen every moment the data is drawn.
 *
 * @param {{credits: Array<{text: string, url?: string}>}} props
 */
export default function MapCredits({ credits }) {
  if (!credits?.length) return null;

  return (
    <div className={styles.credits}>
      {credits.map((credit) => (
        <p key={credit.text} className={styles.credit}>
          {credit.text}
          {/* Some publishers' required statement is a document rather than a
              line: SEPA's flood products need about forty third-party
              statements. OGL v3 permits "including or linking to", so those are
              linked. */}
          {credit.url && (
            <>
              {' '}
              <a
                className={styles.creditLink}
                href={credit.url}
                target="_blank"
                rel="noreferrer"
              >
                Full data attributions
              </a>
            </>
          )}
        </p>
      ))}
    </div>
  );
}
